<template>
<label class="kt-option">
<span class="kt-option__control">
    <span class="kt-radio kt-radio--bold kt-radio--brand">
        <input :class="_class" type="radio" :name="name" v-bind="$attrs" v-bind:value="value"  v-on="listeners">
        <span></span>
    </span>
</span>
<span class="kt-option__label">
    <span class="kt-option__head">
        <span class="kt-option__title">
            {{ label }}
        </span>
    </span>
    <span v-if="hint" class="kt-option__body">{{ hint }}</span>
</span>
</label>

</template>

<script>
export default {
    props: {
        value: {
            default: null
        },
        label: {
            required: true
        },
        hint: {
            default: false
        },
        name: {
            required: true
        }
    },
    model: {
        prop: 'value',
        event: 'checked'
    },
    computed: {
        _class: function() {
            let _class = []

            return _class
        },
        listeners: function () {
            var vm = this
            return Object.assign({},
                this.$listeners,
                {
                    checked: function (event) {
                        vm.$emit('checked', event.target.value)
                    }
                }
            )
        }
    },
}
</script>

<style>

</style>